import RankingAndSorting from '~/utils/translations/RankingAndSorting';
import DiscussionForums from '~/utils/translations/DiscussionForums';
import General from '~/utils/translations/General';
import Like from '~/utils/translations/Like';
import Polls from '~/utils/translations/Polls';
import ParticipantMediaUpload from '~/utils/translations/ParticipantMediaUpload';
import WhatsAppInvite from "@/utils/translations/WhatsAppInvite";
import Misc from "@/utils/translations/Misc";
import Maya from "@/utils/translations/Maya";
import ParticipantPortal from "~/utils/translations/ParticipantPortal";
import ParticipantContact from "~/utils/translations/ParticipantContact";
import ParticipantUserSettings from "~/utils/translations/ParticipantUserSettings";

const languages = [
    'en', 'in', 'zh', 'nl', 'fi',
    'fr', 'de', 'hi', 'it', 'ja',
    'ko', 'pl', 'pt', 'es', 'tr',
    'vi', 'ar'
];

const translations = languages.reduce((acc, lang) => {
    acc[lang] = {
        General: General[lang] || {},
        RankingAndSorting: RankingAndSorting[lang] || {},
        DiscussionForums: DiscussionForums[lang] || {},
        Polls: Polls[lang] || {},
        Like: Like[lang] || {},
        ParticipantMediaUpload: ParticipantMediaUpload[lang] || {},
        WhatsAppInvite: WhatsAppInvite[lang] || {},
        Misc: Misc[lang] || {},
        Maya: Maya[lang] || {},
        ParticipantPortal: {
            ...(ParticipantPortal[lang] || {}),
            ...(ParticipantContact[lang] || {}),
            ...(ParticipantUserSettings[lang] || {}),
        },
    };
    return acc;
}, {});

export default translations;
